import { useEffect, useState } from "react";

/** The builder splits chat and questionnaire side by side from here up. */
export const SPLIT_LAYOUT_QUERY = "(min-width: 1024px)";

const REPLY_NOTE_MAX_CHARS = 140;

function matchesSplitLayout(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return true;
  }
  return window.matchMedia(SPLIT_LAYOUT_QUERY).matches;
}

/**
 * True below the split layout (a phone, or the thread pane's iframe), where
 * the builder shows one of chat or questionnaire at a time.
 */
export function useIsNarrowBuilder(): boolean {
  const [isNarrow, setIsNarrow] = useState(() => !matchesSplitLayout());

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const query = window.matchMedia(SPLIT_LAYOUT_QUERY);
    const onChange = () => setIsNarrow(!query.matches);
    onChange();
    query.addEventListener?.("change", onChange);
    return () => query.removeEventListener?.("change", onChange);
  }, []);

  return isNarrow;
}

/** The first readable line of an assistant reply, for a one-line note. */
export function firstReplyLine(content: string): string {
  const line =
    content
      .split(/\r?\n/)
      .map((part) => part.replace(/^[\s#>*\-•]+/, "").replace(/[*_`]/g, "").trim())
      .find((part) => part.length > 0) ?? "";
  if (line.length <= REPLY_NOTE_MAX_CHARS) {
    return line;
  }
  return `${line.slice(0, REPLY_NOTE_MAX_CHARS - 1).trimEnd()}…`;
}
